import axios from 'axios';
import authHeader from '../auth-header';

import tokenHeader from '../token-header';

import baseUrl from '../base-url';

const API_URL = baseUrl()+"/api/all/";

const getUserGrader = 'user-grader';
const postUserGrader = 'user-grader';
const putUserGrader = 'user-grader/';
const deleteUserGrader = 'user-grader/';
const getUserGraderById = 'user-grader/';
const getUserGraderAktif = 'user-grader';
const getUserGraderTidakAktif = 'user-grader';

class UserGraderService {
    getUserGrader(currentPage,pageSize,filter) {
        return axios.get(
            API_URL + getUserGrader + '?pageNo=' + currentPage + '&pageSize=' + pageSize + '&filter=' + filter,
            {
                headers: authHeader()
            });
    }    

    getUserGraderAktif(currentPage,pageSize,filter) {
        return axios.get(
            API_URL + getUserGraderAktif + '?pageNo=' + currentPage + '&pageSize=' + pageSize + '&filter=' + filter + '&sortBy=id&status=1',
            {
                headers: authHeader()
            });
    }    

    getUserGraderTidakAktif(currentPage,pageSize,filter) {
        return axios.get(
            API_URL + getUserGraderTidakAktif + '?pageNo=' + currentPage + '&pageSize=' + pageSize + '&filter=' + filter + '&sortBy=id&status=0',
            {
                headers: authHeader()
            });
    }    

    postUserGrader(formData) {        
        var headers = authHeader();
        var form = new FormData();

        form.append("name", formData.name);
        form.append("username", formData.username);
        form.append("email", formData.email);
        form.append("noTelephone", formData.noTelephone);
        form.append("alamat", formData.alamat);
        form.append("password",formData.password);
        form.append("status", formData.status);
        form.append("instansi", formData.instansi);
        form.append("namaBank", formData.namaBank);
        form.append("noRekening", formData.noRekening);
        form.append("npwp", formData.npwp);

        if (typeof formData.foto !== 'undefined') {
            form.append("foto", formData.foto);
        }
        
        return axios
        .post(
            API_URL + postUserGrader,
            form,
            {  headers: { 'Content-Type': 'multipart/form-data', 'Authorization': tokenHeader() } }
        );

    }

    putUserGrader(id_user,formData) {

        var form = new FormData();

        form.append("name", formData.name);
        form.append("username", formData.username);
        form.append("email", formData.email);
        form.append("noTelephone", formData.noTelephone);
        form.append("alamat", formData.alamat);
        form.append("password",formData.password);
        form.append("status", formData.status);
        form.append("instansi", formData.instansi);
        form.append("namaBank", formData.namaBank);
        form.append("npwp", formData.npwp);
        form.append("noRekening", formData.noRekening);
        if (typeof formData.foto !== 'undefined') {
            form.append("foto", formData.foto);
        }
        
        return axios
        .put(
            API_URL + putUserGrader + id_user,
            form,
            {  headers: { 'Content-Type': 'multipart/form-data', 'Authorization': tokenHeader() } }
        );

    }

    deleteUserGrader(formData) {
        var headers = authHeader();

        return axios
            .delete(
                API_URL + deleteUserGrader + formData.id,
                { headers: authHeader() }
            );
    }

    getUserGraderById(id) {
        var headers = authHeader();

        return axios
        .get(
            API_URL + getUserGraderById + id,
            { headers: authHeader() }
        );
    }

}

export default new UserGraderService();